export default __webpack_public_path__ + "static/media/edit.102bd29c.svg";